<div class="search-container">
  @if (!searchStore.searching()) {
    <div class="search-icon-container" [class.disabled]="!searchValue" gnxRtl>
      <img src="/assets/svg/search.svg" class="search-icon" (click)="onSearch()" />
    </div>
  }
  @if (searchStore.searching()) {
    <gnx-dots-loader />
  }
  <input
    class="search-input"
    placeholder="{{ 'SEARCH_ANY_VARIANT' | i18n }}"
    [formField]="searchForm.search"
    (input)="onUserInput($any($event.target).value)"
    (paste)="onPaste()"
    (keyup.esc)="onEscape()"
    (keyup.enter)="onSearch()"
  />
  @if ((searchStore.searchDone() && !searchStore.result()) || searchStore.searchError()) {
    <div class="search-error">
      {{ searchStore.searchError() }}
    </div>
  }
  <div class="select-wrapper" [style.flex]="'0 0 86px'">
    <mat-select [(value)]="hgValue">
      <mat-option value="hg19">hg19</mat-option>
      <mat-option value="hg38">hg38</mat-option>
    </mat-select>
  </div>
  <div class="select-wrapper" [style.flex]="'0 0 102px'">
    <mat-select [(value)]="isTumor">
      <mat-option [value]="false">Germline</mat-option>
      <mat-option [value]="true">Somatic</mat-option>
    </mat-select>
  </div>
</div>
<gnx-questionnaire
  #questionnaire
  [closeable]="true"
  [searchTerm]="searchValue"
  (contextChange)="onContextChange($event)"
  (search)="onSearch($event)"
/>
